import FormLabelInput from "../labels/form.label.input";

const FormNumberInput = ({ className, label, value, ...otherProps }) => {
  return (
    <div className={`${className ? className : "w-full"}`}>
      <FormLabelInput>
        {label}:
        {otherProps?.required && <span className="text-red-700 ml-1">*</span>}
      </FormLabelInput>
      <input
        type="number"
        {...otherProps}
        value={value}
        className="w-full text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none"
      />
    </div>
  );
};

export default FormNumberInput;
